import {tokenDefinition} from "../../token/tokenDefinition.mjs";
import {TokenType} from "../../token/tokenType.mjs";
import {TokenName} from "./tokenName.mjs";

const openSpecialElement = tokenDefinition({
    name: TokenName.OPEN_SPECIAL,
    type: TokenType.DELIMITER,
    tokenMatcher: /^\{ */,
    contentMatcher: /^\{ */
});

const closeSpecialElement = tokenDefinition({
    name: TokenName.CLOSE_SPECIAL,
    type: TokenType.DELIMITER,
    tokenMatcher: /^ *\}/,
    contentMatcher: /^ *\}/
});

export {openSpecialElement, closeSpecialElement}
